module.exports = __webpack_public_path__ + "static/media/project-2.53fe0924.png";